// @ts-strict-ignore
import React, { useContext, useEffect } from 'react';
import { useSnackBar } from '@usealloy/component-library';

import { AuthContext, UserContext } from '~/dashboard/context';
import { TitleContext } from '~/dashboard/PageTitleProvider/PageTitleProvider';

declare const window: Window & typeof globalThis & {
  addSnackBar: Function;
};

const withDashboardHooks = Component => function WrappedComponent(props) {
  const addSnackBar = useSnackBar();
  const userContext = useContext(UserContext);
  const authContext = useContext(AuthContext);
  const titleContext = useContext(TitleContext);

  useEffect(() => {
    if (addSnackBar) {
      // please refrain from using this window scope function if possible.
      // in 99% of cases, you do not need to use this.
      window.addSnackBar = addSnackBar;
    }
  }, [addSnackBar]);

  return (
    <Component
      {...props}
      addSnackBar={addSnackBar}
      authContext={authContext}
      userContext={userContext}
      titleContext={titleContext}
    />
  );
};

export default withDashboardHooks;
